import { callerCreator } from "../callerCreator";
import { projectsSlice } from "./projectsSlice";

export default callerCreator(projectsSlice.actions);
